module.exports = __webpack_public_path__ + "static/media/tarra-picturemark-l.16a81128.svg";